export default "__VITE_ASSET__Uxzt6FLG__"